import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { exportRegistrations } from '../api';

/**
 * CheckInExport Component
 *
 * Provides date range selection and CSV export functionality
 */
function CheckInExport() {
  const [startDate, setStartDate] = useState(new Date(Date.now() - 30 * 24 * 60 * 60 * 1000)); // 30 days ago
  const [endDate, setEndDate] = useState(new Date());
  const [exporting, setExporting] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const formatDateForApi = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const handleExport = async () => {
    setExporting(true);
    setError(null);
    setSuccess(null);

    try {
      const result = await exportRegistrations(
        formatDateForApi(startDate),
        formatDateForApi(endDate)
      );

      if (result.success) {
        setSuccess('Export completed! Check your downloads folder.');
        // Clear success message after 5 seconds
        setTimeout(() => setSuccess(null), 5000);
      } else {
        setError(result.message || 'Failed to export data');
      }
    } catch (err) {
      setError(err.message || 'Failed to export data');
    } finally {
      setExporting(false);
    }
  };

  return (
    <div className="export-card">
      <h3>Export Data</h3>
      <div className="export-form">
        <div className="date-field">
          <label>Start Date</label>
          <DatePicker
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            maxDate={endDate}
            dateFormat="MMM d, yyyy"
            className="date-input"
          />
        </div>
        <div className="date-field">
          <label>End Date</label>
          <DatePicker
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
            maxDate={new Date()}
            dateFormat="MMM d, yyyy"
            className="date-input"
          />
        </div>
        <button
          onClick={handleExport}
          className="export-button"
          disabled={exporting}
        >
          {exporting ? (
            <>
              <span className="export-spinner" />
              Exporting...
            </>
          ) : (
            <>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="7 10 12 15 17 10" />
                <line x1="12" y1="15" x2="12" y2="3" />
              </svg>
              Export CSV
            </>
          )}
        </button>
      </div>

      {error && (
        <div className="export-error">
          <p>{error}</p>
        </div>
      )}

      {success && (
        <div className="export-success">
          <p>{success}</p>
        </div>
      )}
    </div>
  );
}

export default CheckInExport;
